/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConsultantViewModel } from './ConsultantViewModel';
import {
    ConsultantViewModelFromJSON,
    ConsultantViewModelFromJSONTyped,
    ConsultantViewModelToJSON,
} from './ConsultantViewModel';
import type { DocumentProgressViewModel } from './DocumentProgressViewModel';
import {
    DocumentProgressViewModelFromJSON,
    DocumentProgressViewModelFromJSONTyped,
    DocumentProgressViewModelToJSON,
} from './DocumentProgressViewModel';
import type { IAPPARTYTYPE } from './IAPPARTYTYPE';
import {
    IAPPARTYTYPEFromJSON,
    IAPPARTYTYPEFromJSONTyped,
    IAPPARTYTYPEToJSON,
} from './IAPPARTYTYPE';
import type { IAPPROPOSALSTATUS } from './IAPPROPOSALSTATUS';
import {
    IAPPROPOSALSTATUSFromJSON,
    IAPPROPOSALSTATUSFromJSONTyped,
    IAPPROPOSALSTATUSToJSON,
} from './IAPPROPOSALSTATUS';
import type { IAPSIGNINGOPTIONS } from './IAPSIGNINGOPTIONS';
import {
    IAPSIGNINGOPTIONSFromJSON,
    IAPSIGNINGOPTIONSFromJSONTyped,
    IAPSIGNINGOPTIONSToJSON,
} from './IAPSIGNINGOPTIONS';
import type { QuoteAndApplicationDocumentViewModel } from './QuoteAndApplicationDocumentViewModel';
import {
    QuoteAndApplicationDocumentViewModelFromJSON,
    QuoteAndApplicationDocumentViewModelFromJSONTyped,
    QuoteAndApplicationDocumentViewModelToJSON,
} from './QuoteAndApplicationDocumentViewModel';
import type { SupportingDocumentViewModel } from './SupportingDocumentViewModel';
import {
    SupportingDocumentViewModelFromJSON,
    SupportingDocumentViewModelFromJSONTyped,
    SupportingDocumentViewModelToJSON,
} from './SupportingDocumentViewModel';

/**
 * 
 * @export
 * @interface SigningProgressSummaryViewModel
 */
export interface SigningProgressSummaryViewModel {
    /**
     * 
     * @type {IAPSIGNINGOPTIONS}
     * @memberof SigningProgressSummaryViewModel
     */
    signingMethod?: IAPSIGNINGOPTIONS;
    /**
     * 
     * @type {number}
     * @memberof SigningProgressSummaryViewModel
     */
    productId: number;
    /**
     * 
     * @type {IAPPARTYTYPE}
     * @memberof SigningProgressSummaryViewModel
     */
    partyType: IAPPARTYTYPE;
    /**
     * 
     * @type {QuoteAndApplicationDocumentViewModel}
     * @memberof SigningProgressSummaryViewModel
     */
    quoteAndApplicationDocument: QuoteAndApplicationDocumentViewModel;
    /**
     * 
     * @type {ConsultantViewModel}
     * @memberof SigningProgressSummaryViewModel
     */
    consultant?: ConsultantViewModel;
    /**
     * 
     * @type {boolean}
     * @memberof SigningProgressSummaryViewModel
     */
    isProposalLocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SigningProgressSummaryViewModel
     */
    isCancelSigningAllowed: boolean;
    /**
     * 
     * @type {IAPPROPOSALSTATUS}
     * @memberof SigningProgressSummaryViewModel
     */
    proposalStatus: IAPPROPOSALSTATUS;
    /**
     * 
     * @type {Array<DocumentProgressViewModel>}
     * @memberof SigningProgressSummaryViewModel
     */
    documentProgresses: Array<DocumentProgressViewModel>;
    /**
     * 
     * @type {Array<SupportingDocumentViewModel>}
     * @memberof SigningProgressSummaryViewModel
     */
    nonSigningDocuments: Array<SupportingDocumentViewModel>;
    /**
     * 
     * @type {boolean}
     * @memberof SigningProgressSummaryViewModel
     */
    signaturesPlaced?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SigningProgressSummaryViewModel
     */
    viewingLink?: string;
    /**
     * 
     * @type {Date}
     * @memberof SigningProgressSummaryViewModel
     */
    dateSubmittedForESigning?: Date;
    /**
     * 
     * @type {Array<SupportingDocumentViewModel>}
     * @memberof SigningProgressSummaryViewModel
     */
    downloadAndSignDocuments?: Array<SupportingDocumentViewModel>;
}

/**
 * Check if a given object implements the SigningProgressSummaryViewModel interface.
 */
export function instanceOfSigningProgressSummaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "partyType" in value;
    isInstance = isInstance && "quoteAndApplicationDocument" in value;
    isInstance = isInstance && "isProposalLocked" in value;
    isInstance = isInstance && "isCancelSigningAllowed" in value;
    isInstance = isInstance && "proposalStatus" in value;
    isInstance = isInstance && "documentProgresses" in value;
    isInstance = isInstance && "nonSigningDocuments" in value;

    return isInstance;
}

export function SigningProgressSummaryViewModelFromJSON(json: any): SigningProgressSummaryViewModel {
    return SigningProgressSummaryViewModelFromJSONTyped(json, false);
}

export function SigningProgressSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningProgressSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signingMethod': !exists(json, 'SigningMethod') ? undefined : IAPSIGNINGOPTIONSFromJSON(json['SigningMethod']),
        'productId': json['ProductId'],
        'partyType': IAPPARTYTYPEFromJSON(json['PartyType']),
        'quoteAndApplicationDocument': QuoteAndApplicationDocumentViewModelFromJSON(json['QuoteAndApplicationDocument']),
        'consultant': !exists(json, 'Consultant') ? undefined : ConsultantViewModelFromJSON(json['Consultant']),
        'isProposalLocked': json['IsProposalLocked'],
        'isCancelSigningAllowed': json['IsCancelSigningAllowed'],
        'proposalStatus': IAPPROPOSALSTATUSFromJSON(json['ProposalStatus']),
        'documentProgresses': ((json['DocumentProgresses'] as Array<any>).map(DocumentProgressViewModelFromJSON)),
        'nonSigningDocuments': ((json['NonSigningDocuments'] as Array<any>).map(SupportingDocumentViewModelFromJSON)),
        'signaturesPlaced': !exists(json, 'SignaturesPlaced') ? undefined : json['SignaturesPlaced'],
        'viewingLink': !exists(json, 'ViewingLink') ? undefined : json['ViewingLink'],
        'dateSubmittedForESigning': !exists(json, 'DateSubmittedForESigning') ? undefined : (new Date(json['DateSubmittedForESigning'])),
        'downloadAndSignDocuments': !exists(json, 'DownloadAndSignDocuments') ? undefined : ((json['DownloadAndSignDocuments'] as Array<any>).map(SupportingDocumentViewModelFromJSON)),
    };
}

export function SigningProgressSummaryViewModelToJSON(value?: SigningProgressSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'SigningMethod': IAPSIGNINGOPTIONSToJSON(value.signingMethod),
        'ProductId': value.productId,
        'PartyType': IAPPARTYTYPEToJSON(value.partyType),
        'QuoteAndApplicationDocument': QuoteAndApplicationDocumentViewModelToJSON(value.quoteAndApplicationDocument),
        'Consultant': ConsultantViewModelToJSON(value.consultant),
        'IsProposalLocked': value.isProposalLocked,
        'IsCancelSigningAllowed': value.isCancelSigningAllowed,
        'ProposalStatus': IAPPROPOSALSTATUSToJSON(value.proposalStatus),
        'DocumentProgresses': ((value.documentProgresses as Array<any>).map(DocumentProgressViewModelToJSON)),
        'NonSigningDocuments': ((value.nonSigningDocuments as Array<any>).map(SupportingDocumentViewModelToJSON)),
        'SignaturesPlaced': value.signaturesPlaced,
        'ViewingLink': value.viewingLink,
        'DateSubmittedForESigning': value.dateSubmittedForESigning === undefined ? undefined : (value.dateSubmittedForESigning.toISOString()),
        'DownloadAndSignDocuments': value.downloadAndSignDocuments === undefined ? undefined : ((value.downloadAndSignDocuments as Array<any>).map(SupportingDocumentViewModelToJSON)),
    };
}

